
const _defaultConfig = {
    /**
     * number of image slots to leave blank at beginning of first row
     */
    columnOffset: 0,
    /**
     * number of images to be displayed side-by-side
     */
    numColumns: 1,
    /**
     * margin between individual rows
     */
    rowMargin: 0
}

class ImagesLayout {

    constructor(config) {
        this.config = jQuery.extend(true, {}, _defaultConfig, config);
    }

    calculateBounds(originalBounds) {

        const calculatedBounds = [];
        const medianBounds = _medianBounds(originalBounds);
        for (let i = 0; i < originalBounds.length; i++) {
            const gridPosition = i + this.config.columnOffset;
            const columnNumber = gridPosition % this.config.numColumns;
            const currentImage = originalBounds[i];
            const imageBefore = i > 0 && columnNumber > 0 ? calculatedBounds[i-1] : undefined;
            const imageAbove = i >= this.config.numColumns ? calculatedBounds[Math.max(0, i-this.config.numColumns)] : undefined;
            let calculatedImage = currentImage.clone();

            const imageAspectRatio = currentImage.getAspectRatio();

            if(imageBefore) {
                const scale = calculatedImage.height/imageBefore.height;
                calculatedImage = calculatedImage.times(scale);
            } else if(imageAspectRatio < medianBounds.getAspectRatio()) {
                const k = medianBounds.height/currentImage.height;
                calculatedImage = calculatedImage.times(k);
                calculatedImage.x += 0.5 * (imageAbove ? imageAbove.width : 1) - calculatedImage.width/2;
            } else if(imageAspectRatio >  medianBounds.getAspectRatio()) {
                const k = currentImage.width/medianBounds.width;
                calculatedImage = calculatedImage.times(k);
            }

            //move image to correct position in grid
            calculatedImage.x += imageBefore ? imageBefore.getBottomRight().x : 0;
            calculatedImage.y += imageAbove ? imageAbove.getBottomRight().y + this.config.rowMargin : 0;

            calculatedBounds.push(calculatedImage);
        }
        return calculatedBounds;
    }

}

function  _medianBounds(dimensions) {

    if(!(dimensions instanceof Array) || dimensions.length < 1) {
        return undefined;
    } else if(dimensions.length == 1) {
        return dimensions[0];
    }
    const sorted = Array.from(dimensions).sort((a, b) => a.width * a.height - b.width * b.height);
    const middle = Math.floor(sorted.length / 2);

    return sorted[middle];
}

export default ImagesLayout;
